import { useMasters } from "./masters";
import { defineStore } from "pinia";
import { reactive } from "vue";

let alertId = 0;

export const errorData = {
  type: "error",
  icon: "mdi-alert-circle",
  iconColor: "brand-lighten-3",
  borderColor: "error",
};

export const successData = {
  type: "success",
  icon: "mdi-check-circle",
  iconColor: "success",
  borderColor: "success",
};

export const warningData = {
  type: "warning",
  icon: "mdi-alert",
  iconColor: "warning",
  borderColor: "warning",
};

export const infoData = {
  type: "info",
  icon: "mdi-information",
  iconColor: "light-blue-lighten-1",
  borderColor: "light-blue-lighten-1",
};

export const useWarningStore = defineStore("globalMessage", {
  state: () => ({
    alerts: reactive([]),
    info: {
      show: false,
      text: "",
    },
  }),

  actions: {
    /**
     * Show an alert message
     * @param {Object} data
     * @returns
     */
    showAlert(data) {
      if (this.alreadyWarned(data.message)) {
        return;
      }
      const id = alertId++;
      this.alerts.push({
        id,
        ...data,
        visible: true,
      });
    },

    /**
     * Hide an alert by its ID
     * @param {String} id
     */
    hideAlert(id) {
      const index = this.alerts.findIndex((alert) => alert.id === id);
      if (index !== -1) {
        this.alerts.splice(index, 1);
      }
    },

    /**
     * Show a generic error message
     * @param {String} messageText
     * @param {Boolean} timeout
     */
    showGenericErrorMessage(messageText, timeout = false) {
      const data = {
        ...errorData,
        message: messageText,
        timeout: timeout ? 6000 : -1,
      };
      this.showAlert(data);
    },

    /**
     * Show a generic success message
     * @param {String} messageText
     * @param {Boolean} timeout
     */
    showGenericSuccessMessage(messageText, timeout = true) {
      const data = {
        ...successData,
        message: messageText,
        timeout: timeout ? 6000 : -1,
      };
      this.showAlert(data);
    },

    /**
     * Show a generic Warning message
     * @param {String} messageText
     * @param {Boolean} timeout
     */
    showGenericWarningMessage(messageText, timeout = false) {
      const data = {
        ...warningData,
        message: messageText,
        timeout: timeout ? 6000 : -1,
      };
      this.showAlert(data);
    },

    /**
     * Show a generic Info message
     * @param {String} messageText
     * @param {Boolean} timeout
     */
    showGenericInfoMessage(messageText, timeout = false) {
      const data = {
        ...infoData,
        message: messageText,
        timeout: timeout ? 6000 : -1,
      };

      this.showAlert(data);
    },
    /**
     * Clean info message
     */
    cleanInfoMessage() {
      const masters = useMasters();
      masters.setGlobalLoading(false);
      this.info.show = false;
      this.info.text = "";
    },
    /**
     * Set info message
     * @param {String} messageText
     */
    setInfoMessage(messageText) {
      const nuxtApp = useNuxtApp();
      const masters = useMasters();
      masters.setGlobalLoading(true);
      this.info.show = true;

      this.info.text =
        messageText || nuxtApp.$i18n.t("common.messages.waiting");
    },
    /**
     * Remove all alerts
     */
    removeAllAlerts() {
      this.alerts = [];
    },
  },
  getters: {
    /**
     * Check if a message has already been shown
     * @param {String} Message
     * @returns
     */
    alreadyWarned: (state) => (message) => {
      // Lógica para verificar si el mensaje ya fue mostrado
      return state.alerts.some(
        (alert) => JSON.stringify(alert.message) === JSON.stringify(message)
      );
    },
  },
});
